/**
 * Route and UI capabilities by JWT role.
 * Keep in sync with server `authorizeRoles` on each API.
 */

const ROLES = ["admin", "manager", "designer"];

export function normalizeRole(role) {
  const r = typeof role === "string" ? role.trim().toLowerCase() : "";
  return ROLES.includes(r) ? r : null;
}

export function getRoleCapabilities(role) {
  const r = normalizeRole(role);
  const isAdmin = r === "admin";
  const isManager = r === "manager";
  const isDesigner = r === "designer";

  return {
    role: r,
    isAdmin,
    isManager,
    isDesigner,

    canAccessDashboard: isAdmin,
    canAccessUsers: isAdmin,
    canAccessClients: isAdmin || isManager,
    canAccessBrandsAndLayouts: isAdmin || isDesigner,
    canCreateClients: isAdmin || isManager,
    canEditClients: isAdmin || isManager,
    canDeleteClients: isAdmin,
    canAssignBrands: isAdmin || isManager,
    canTransferBrandsBetweenDesigners: isAdmin || isManager,
    canManageLayouts: isAdmin || isDesigner,
    canDeleteLayouts: isAdmin,
    canAccessDemoModules: isAdmin,
    /** Admin: shared backgrounds & SVG vectors for the HTML layout editor */
    canAccessDesignLibrary: isAdmin,
    canAccessChatbotSettings: isAdmin,
    canUseSettingsUi: isAdmin || isManager || isDesigner,
  };
}
